/* ========================================
   DAYS THEME: GRID TOGGLE RESPONSIVO

   MOBILE (<750px):    2 colunas (padrão) ↔ 1 coluna (zoom)
   TABLET (750-989px): 3 colunas (padrão) ↔ 2 colunas (zoom)
   DESKTOP (≥990px):   5 colunas (padrão) ↔ 3 colunas (zoom)
   ======================================== */

class YeezyGridToggle {
  constructor() {
    this.button = document.getElementById('yeezy-grid-toggle-btn');
    this.productGrid = null;

    // Breakpoints (mesmos do CSS)
    this.breakpoints = {
      mobile: 749,
      tablet: 989
    };

    // Configuração de colunas por breakpoint
    this.gridConfig = {
      mobile: { default: 2, zoomed: 1 },
      tablet: { default: 3, zoomed: 2 },
      desktop: { default: 5, zoomed: 3 }
    };

    // Estado atual
    this.currentBreakpoint = this.getBreakpoint();
    this.isZoomed = this.getStoredState();

    console.log('🔧 [GridToggle] Inicializado', {
      button: this.button ? 'encontrado' : 'NÃO ENCONTRADO',
      breakpoint: this.currentBreakpoint,
      isZoomed: this.isZoomed,
      windowWidth: window.innerWidth
    });

    this.init();
  }

  init() {
    if (!this.button) {
      console.error('❌ [GridToggle] Botão não encontrado! ID: yeezy-grid-toggle-btn');
      return;
    }

    console.log('✅ [GridToggle] Botão encontrado, adicionando listeners');

    // Listener no botão
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('🖱️ [GridToggle] Botão clicado!', {
        breakpoint: this.currentBreakpoint,
        gridEncontrado: this.productGrid ? 'SIM' : 'NÃO'
      });
      this.toggle();
    });

    // Listener para resize de janela
    window.addEventListener('resize', () => this.handleResize());

    // Encontrar e aplicar grid
    this.findGrid();
  }

  getBreakpoint() {
    const width = window.innerWidth;

    if (width <= this.breakpoints.mobile) {
      return 'mobile';
    } else if (width <= this.breakpoints.tablet) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  handleResize() {
    const newBreakpoint = this.getBreakpoint();

    // Se mudou de breakpoint, reaplicar grid
    if (newBreakpoint !== this.currentBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      // Buscar estado armazenado para novo breakpoint
      this.isZoomed = this.getStoredState();

      this.applyGridColumns();
    }
  }

  findGrid() {
    // Tentar múltiplas vezes com delay (AJAX pode carregar depois)
    const attempts = [0, 100, 300, 500, 1000, 2000];

    attempts.forEach(delay => {
      setTimeout(() => {
        if (!this.productGrid) {
          // Priorizar grid com classe yeezy-product-grid (páginas de coleção)
          let grid = document.querySelector('.yeezy-product-grid');

          // Fallback para #product-grid
          if (!grid) {
            grid = document.getElementById('product-grid');
          }

          // Fallback para .product-grid (home page e outras)
          if (!grid) {
            grid = document.querySelector('.product-grid');
          }

          // Fallback para grid dentro de slider-component (featured-collection na home)
          if (!grid) {
            grid = document.querySelector('slider-component .grid.contains-card--product');
          }

          if (grid && grid.children.length > 0) {
            this.productGrid = grid;

            console.log('✅ [GridToggle] Grid encontrado!', {
              selector: grid.className,
              filhos: grid.children.length,
              delay: delay + 'ms'
            });

            // Adicionar classe yeezy-product-grid se não tiver (para CSS funcionar)
            if (!this.productGrid.classList.contains('yeezy-product-grid')) {
              this.productGrid.classList.add('yeezy-product-grid');
              console.log('➕ [GridToggle] Classe yeezy-product-grid adicionada');
            }

            this.applyGridColumns();
          } else if (delay === 2000) {
            // Último attempt falhou
            console.error('❌ [GridToggle] Grid NÃO encontrado após todos os attempts!');
          }
        }
      }, delay);
    });
  }

  toggle() {
    if (!this.productGrid) {
      console.error('❌ [GridToggle] Toggle cancelado - grid não encontrado');
      return;
    }

    // Alternar estado de zoom
    this.isZoomed = !this.isZoomed;

    console.log('🔄 [GridToggle] Toggle executado', {
      breakpoint: this.currentBreakpoint,
      isZoomed: this.isZoomed,
      colunas: this.isZoomed ? this.gridConfig[this.currentBreakpoint].zoomed : this.gridConfig[this.currentBreakpoint].default
    });

    // Salvar no localStorage
    this.saveState();

    // Aplicar classes
    this.applyGridColumns();
  }

  applyGridColumns() {
    if (!this.productGrid) return;

    const breakpoint = this.currentBreakpoint;
    const config = this.gridConfig[breakpoint];

    // Determinar número de colunas
    const columns = this.isZoomed ? config.zoomed : config.default;

    // Remover TODAS as classes de grid existentes
    this.productGrid.classList.remove(
      // Desktop
      'grid--3-col-desktop',
      'grid--5-col-desktop',
      // Tablet
      'grid--2-col-tablet',
      'grid--3-col-tablet',
      // Mobile
      'grid--1-col-mobile',
      'grid--2-col-mobile',
      // Dawn classes (home page)
      'grid--1-col-tablet-down',
      'grid--2-col-tablet-down'
    );

    // Adicionar classe correta baseada no breakpoint e colunas
    let className = '';

    if (breakpoint === 'desktop') {
      className = `grid--${columns}-col-desktop`;
    } else if (breakpoint === 'tablet') {
      className = `grid--${columns}-col-tablet`;
    } else { // mobile
      // Usar classe -tablet-down para compatibilidade com home page
      className = `grid--${columns}-col-tablet-down`;
    }

    this.productGrid.classList.add(className);

    console.log('📐 [GridToggle] Classes aplicadas', {
      removidas: 'grid--*-col-*',
      adicionada: className,
      colunas: columns
    });

    // Atualizar estado visual do botão
    if (this.isZoomed) {
      this.button.classList.add('is-zoomed');
    } else {
      this.button.classList.remove('is-zoomed');
    }

    // Adicionar data attribute para referência
    this.productGrid.dataset.gridColumns = columns;
    this.productGrid.dataset.gridBreakpoint = breakpoint;

    // Atualizar ícone do botão
    this.updateButtonIcon();
  }

  updateButtonIcon() {
    if (!this.button) return;

    // Zoomed = arrow-left (voltar/menos colunas)
    // Default = plus (mais colunas/zoom)
    if (this.isZoomed) {
      this.button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
      `;
    } else {
      this.button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
      `;
    }
  }

  getStoredState() {
    // Chave específica por breakpoint
    const key = `days-grid-${this.currentBreakpoint}-zoomed`;
    const stored = localStorage.getItem(key);

    // Default: false (não zoomed)
    return stored === 'true';
  }

  saveState() {
    // Salvar estado específico para este breakpoint
    const key = `days-grid-${this.currentBreakpoint}-zoomed`;
    localStorage.setItem(key, this.isZoomed.toString());
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new YeezyGridToggle();
  });
} else {
  new YeezyGridToggle();
}
